import { useEffect, useState } from 'react';
import { fetchMyVenues, type MyVenueItem } from '../socialApi';

type Props = { limit: number; compact?: boolean; onOpenVenue: (venueId: string) => void; onShowAll?: () => void };

function openVenueXpHistory(venueId: string): void {
  const query = new URLSearchParams({ section: 'xp', venue_id: venueId });
  window.location.assign(`/profile?${query.toString()}`);
}

export function ProfileVenuesSection({ limit, compact = false, onOpenVenue, onShowAll }: Props) {
  const [items, setItems] = useState<MyVenueItem[]>([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    void fetchMyVenues('recent', limit)
      .then((response) => {
        if (!cancelled) {
          setItems(response.data);
          setTotal(response.meta.total);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setItems([]);
          setTotal(0);
        }
      })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [limit]);

  return (
    <section className={`profile-reference-card profile-venues-workspace${compact ? ' is-compact' : ''}`}>
      <div className="profile-reference-card__heading">
        <h2>Мои заведения</h2>
        {onShowAll && <button type="button" onClick={onShowAll}>Смотреть все</button>}
      </div>
      {loading ? (
        <p className="profile-inline-state">Загружаем места…</p>
      ) : items.length === 0 ? (
        <p className="profile-inline-state">Здесь появятся посещённые заведения.</p>
      ) : (
        <div className="profile-compact-list">
          {items.map((item) => (
            <div className="profile-venue-history-row" key={item.venue.id}>
              <button type="button" onClick={() => onOpenVenue(item.venue.id)}>
                <span>
                  <strong>{item.venue.name ?? 'Место Хоппера'}</strong>
                  <small>
                    {item.last_visit_at
                      ? `Последний визит: ${new Intl.DateTimeFormat('ru-RU', { day: 'numeric', month: 'short' }).format(new Date(item.last_visit_at))}`
                      : 'Подтверждённый визит'}
                  </small>
                </span>
                <b>{item.xp_total.toLocaleString('ru-RU')} XP</b>
              </button>
              {!compact && (
                <button className="profile-venue-history-row__xp" type="button" onClick={() => openVenueXpHistory(item.venue.id)}>
                  История XP этого места
                </button>
              )}
            </div>
          ))}
        </div>
      )}
      {!compact && total > items.length && (
        <p className="profile-list-cap-note">Показаны последние {items.length} из {total}. Расширенная пагинация появится отдельно.</p>
      )}
    </section>
  );
}
